/* eslint-disable react/prop-types */
import useConnectionContext from '@/hooks/useConnectionContext';
import useProductsContext from '@/hooks/useProductsContext';
import classes from './Tab2.module.css';
import StoreConnectionCard from './StoreConnectionCard';
import { popupCenter } from '../../utils';
import StoreActiveProducts from './StoreActiveProducts';

export default function StoresInfo() {
  const {
    isLoading, store,
  } = useConnectionContext();
  const { productsInvolved, involvedLoading } = useProductsContext();

  const storeClickHandler = () => {
    const shop = store.info;
    popupCenter({
      url: shop ? `https://${process.env.SHOPIFY_APP_INSALLATION_URI}?shop=${encodeURIComponent(shop)}` : '/connect-store', title: '', w: 800, h: 600,
    });
  };
  return (
    <div className={classes.card}>
      <StoreConnectionCard
        isLoading={isLoading}
        data={store}
        clickHandler={storeClickHandler}
      />
      <StoreActiveProducts products={productsInvolved} loading={involvedLoading} />
    </div>
  );
}
